import React, { useState } from 'react';

const CaseDetailView = ({ caseItem, onClose, onUpdate }) => {
  const [activeTab, setActiveTab] = useState('details');
  const [documents, setDocuments] = useState([
    { id: 1, name: 'Αγωγή.pdf', type: 'Δικόγραφο', size: '245 KB', date: '2025-01-15', folder: 'dikografa' },
    { id: 2, name: 'Πληρεξούσιο.pdf', type: 'Πληρεξούσιο', size: '120 KB', date: '2025-01-10', folder: 'dikografa' },
    { id: 3, name: 'Μαρτυρική Κατάθεση.docx', type: 'Αποδεικτικό', size: '89 KB', date: '2025-02-01', folder: 'apodeiktika' },
  ]);
  const [timeline, setTimeline] = useState([
    { id: 1, date: '2025-01-10', action: 'Ανάληψη υπόθεσης', user: 'Δικηγόρος', type: 'start' },
    { id: 2, date: '2025-01-15', action: 'Κατάθεση αγωγής', user: 'Δικηγόρος', type: 'court' },
    { id: 3, date: '2025-02-01', action: 'Λήψη μαρτυρικής κατάθεσης', user: 'Δικηγόρος', type: 'document' },
    { id: 4, date: '2025-02-20', action: 'Επικοινωνία με αντίδικο δικηγόρο', user: 'Δικηγόρος', type: 'communication' },
  ]);
  const [finances, setFinances] = useState({
    honoraria: 3000, retainer: 1500, courtFees: 350, grammatic: 186,
    stamps: 45, expertFees: 0, otherExpenses: 120,
    payments: [
      { id: 1, date: '2025-01-10', amount: 1500, method: 'Κατάθεση', status: 'paid', invoice: 'ΤΠΥ-001' },
      { id: 2, date: '2025-02-15', amount: 1000, method: 'Μεταφορά', status: 'paid', invoice: 'ΤΠΥ-002' },
    ]
  });
  const [notes, setNotes] = useState([
    { id: 1, date: '2025-01-15', text: 'Ο εντολέας επιθυμεί εξωδικαστική επίλυση αν είναι δυνατόν', pinned: true },
    { id: 2, date: '2025-02-01', text: 'Ο μάρτυρας είναι αξιόπιστος, καλή κατάθεση', pinned: false },
  ]);
  const [todos, setTodos] = useState([
    { id: 1, text: 'Προετοιμασία προτάσεων', done: false, due: '2025-03-10', priority: 'high' },
    { id: 2, text: 'Συλλογή εγγράφων από εντολέα', done: true, due: '2025-02-15', priority: 'medium' },
    { id: 3, text: 'Επικοινωνία με αντίδικο για συμβιβασμό', done: false, due: '2025-03-01', priority: 'medium' },
    { id: 4, text: 'Κατάθεση προτάσεων στο δικαστήριο', done: false, due: '2025-03-15', priority: 'high' },
  ]);
  const [deadlines, setDeadlines] = useState([
    { id: 1, title: 'Κατάθεση Προτάσεων', date: '2025-03-15', type: 'court', reminder: [7,3,1], status: 'pending' },
    { id: 2, title: 'Επόμενη Συζήτηση', date: caseItem?.nextHearing || '2025-03-20', type: 'hearing', reminder: [7,3,1], status: 'pending' },
    { id: 3, title: 'Παραγραφή Αξίωσης', date: '2027-01-10', type: 'statute', reminder: [90,30,7], status: 'warning' },
  ]);
  const [newNote, setNewNote] = useState('');
  const [newTodo, setNewTodo] = useState('');
  const [selectedFolder, setSelectedFolder] = useState('all');

  if (!caseItem) return null;

  const tabs = [
    { id: 'details', label: '📋 Στοιχεία', },
    { id: 'documents', label: '📁 Έγγραφα' },
    { id: 'calendar', label: '📅 Ημερολόγιο' },
    { id: 'finances', label: '💰 Οικονομικά' },
    { id: 'notes', label: '📝 Σημειώσεις' },
    { id: 'jurisprudence', label: '⚖️ Νομολογία' },
  ];

  const folders = [
    { id: 'all', label: 'Όλα', icon: '📂' },
    { id: 'dikografa', label: 'Δικόγραφα', icon: '📄' },
    { id: 'apodeiktika', label: 'Αποδεικτικά', icon: '🔍' },
    { id: 'allilografia', label: 'Αλληλογραφία', icon: '✉️' },
    { id: 'court', label: 'Δικαστικά', icon: '⚖️' },
    { id: 'other', label: 'Λοιπά', icon: '📎' },
  ];

  const totalCosts = finances.courtFees + finances.grammatic + finances.stamps + finances.expertFees + finances.otherExpenses;
  const totalPaid = finances.payments.filter(p => p.status === 'paid').reduce((s, p) => s + p.amount, 0);
  const totalDue = finances.honoraria + totalCosts - totalPaid;

  const filteredDocs = selectedFolder === 'all' ? documents : documents.filter(d => d.folder === selectedFolder);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      setDocuments(prev => [...prev, {
        id: Date.now() + Math.random(),
        name: file.name,
        type: 'Νέο',
        size: (file.size / 1024).toFixed(0) + ' KB',
        date: new Date().toISOString().split('T')[0],
        folder: selectedFolder === 'all' ? 'other' : selectedFolder,
      }]);
    });
  };

  const s = {
    label: { fontSize: 11, color: '#64748B', marginBottom: 2 },
    value: { fontSize: 14, fontWeight: 600, color: '#1E293B' },
    section: { fontSize: 14, fontWeight: 700, color: '#1E293B', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 },
    card: { background: '#FFF', borderRadius: 12, border: '1px solid #E2E8F0', padding: 16, marginBottom: 12 },
    btn: { padding: '8px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' },
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, display: 'flex' }} onClick={onClose}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }} />
      <div style={{
        position: 'relative', background: '#F8FAFC', width: '95%', maxWidth: 1100, height: '95vh',
        margin: 'auto', borderRadius: 16, display: 'flex', flexDirection: 'column',
        boxShadow: '0 25px 50px rgba(0,0,0,0.3)', overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: '16px 24px', background: '#1E293B', color: '#FFF', flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
                <span style={{ background: '#3B82F6', padding: '2px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>{caseItem.caseNumber}</span>
                <span style={{ background: caseItem.type === 'civil' ? '#3B82F6' : caseItem.type === 'labor' ? '#10B981' : '#8B5CF6',
                  padding: '2px 10px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>{caseItem.typeLabel}</span>
                <span style={{ background: '#10B981', padding: '2px 10px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>Ενεργή</span>
              </div>
              <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>{caseItem.title}</h2>
              <p style={{ fontSize: 13, color: '#94A3B8' }}>{caseItem.clientName} • {caseItem.court}</p>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ textAlign: 'center', background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '8px 16px' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: caseItem.aiSuccessRate >= 75 ? '#10B981' : '#F59E0B' }}>
                  {caseItem.aiSuccessRate}%
                </div>
                <div style={{ fontSize: 10, color: '#94A3B8' }}>AI Πρόβλεψη</div>
              </div>
              <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#FFF',
                width: 36, height: 36, borderRadius: 8, fontSize: 18, cursor: 'pointer' }}>✕</button>
            </div>
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', gap: 4, marginTop: 12 }}>
            {tabs.map(tab => (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
                padding: '8px 14px', borderRadius: '8px 8px 0 0', fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer',
                background: activeTab === tab.id ? '#F8FAFC' : 'rgba(255,255,255,0.08)',
                color: activeTab === tab.id ? '#1E293B' : '#94A3B8',
              }}>{tab.label}</button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 24 }}>

          {/* ===== ΣΤΟΙΧΕΙΑ TAB ===== */}
          {activeTab === 'details' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                {/* Case Info */}
                <div style={s.card}>
                  <div style={s.section}>📋 Στοιχεία Υπόθεσης</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    {[
                      ['Αρ. Δικογραφίας', caseItem.courtFileNumber],
                      ['Δικαστήριο', caseItem.court],
                      ['Αξία Διαφοράς', '€' + caseItem.estimatedValue?.toLocaleString()],
                      ['Επόμενη Συζήτηση', caseItem.nextHearing ? new Date(caseItem.nextHearing).toLocaleDateString('el-GR') : '-'],
                    ].map(([label, val], i) => (
                      <div key={i}><div style={s.label}>{label}</div><div style={s.value}>{val}</div></div>
                    ))}
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <div style={s.label}>Περιγραφή</div>
                    <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.6 }}>{caseItem.description}</div>
                  </div>
                </div>

                {/* Opponent */}
                <div style={s.card}>
                  <div style={s.section}>⚔️ Αντίδικος</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    {[
                      ['Ονοματεπώνυμο', 'Κ. Αλεξανδρίδης'],
                      ['ΑΦΜ', '123456789'],
                      ['Δικηγόρος Αντιδίκου', 'Ν. Σταυρόπουλος'],
                      ['Τηλ. Δικηγόρου', '+30 210 9876543'],
                    ].map(([label, val], i) => (
                      <div key={i}><div style={s.label}>{label}</div><div style={s.value}>{val}</div></div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                    <button style={{ ...s.btn, background: '#EFF6FF', color: '#2563EB' }} onClick={() => window.open('mailto:n.stavropoulos@example.com')}>📧 Email Αντιδίκου</button>
                    <button style={{ ...s.btn, background: '#F0FDF4', color: '#059669' }} onClick={() => window.open('tel:+302109876543')}>📞 Κλήση</button>
                  </div>
                </div>
              </div>

              {/* Timeline */}
              <div style={s.card}>
                <div style={s.section}>🕐 Χρονολόγιο Υπόθεσης</div>
                <div style={{ position: 'relative', paddingLeft: 24 }}>
                  {timeline.map((entry, i) => (
                    <div key={entry.id} style={{ display: 'flex', gap: 12, marginBottom: 16, position: 'relative' }}>
                      <div style={{
                        position: 'absolute', left: -24, top: 4, width: 12, height: 12, borderRadius: '50%',
                        background: entry.type === 'start' ? '#10B981' : entry.type === 'court' ? '#3B82F6' : entry.type === 'document' ? '#F59E0B' : '#8B5CF6',
                        border: '2px solid #FFF', boxShadow: '0 0 0 2px #E2E8F0',
                      }} />
                      {i < timeline.length - 1 && (
                        <div style={{ position: 'absolute', left: -19, top: 18, width: 2, height: 'calc(100% + 4px)', background: '#E2E8F0' }} />
                      )}
                      <div>
                        <div style={{ fontSize: 11, color: '#94A3B8' }}>{new Date(entry.date).toLocaleDateString('el-GR')}</div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#1E293B' }}>{entry.action}</div>
                        <div style={{ fontSize: 11, color: '#64748B' }}>{entry.user}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ===== ΕΓΓΡΑΦΑ TAB ===== */}
          {activeTab === 'documents' && (
            <div>
              {/* Toolbar */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <button onClick={() => document.getElementById('caseFileUpload').click()}
                  style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}>📤 Ανέβασμα Αρχείου</button>
                <input id="caseFileUpload" type="file" multiple className="hidden" style={{ display: 'none' }} onChange={handleFileUpload} />
                <button style={{ ...s.btn, background: '#EFF6FF', color: '#2563EB' }}
                  onClick={() => alert('📷 Η λειτουργία σάρωσης θα ανοίξει την κάμερα στο κινητό')}>📷 Σάρωση</button>
                <button style={{ ...s.btn, background: '#FEF3C7', color: '#92400E' }}
                  onClick={() => window.open('https://drive.google.com', '_blank')}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24"><path d="M4.433 22l-1.6-2.733L9.767 7.6h4.4l-6.933 11.867L4.433 22z" fill="#0066DA"/><path d="M20.267 22H7.233l2.2-3.733h13.034L20.267 22z" fill="#00AC47"/><path d="M22.467 18.267L15.533 6.4l-2.2 3.733 4.734 8.134h4.4z" fill="#EA4335"/><path d="M9.767 7.6L7.567 3.867h4.4L14.167 7.6H9.767z" fill="#00832D"/><path d="M15.533 6.4h-4.4l2.2-3.733h4.4L15.533 6.4z" fill="#2684FC"/><path d="M8.467 14L6.267 10.267 4.067 14l2.2 3.733L8.467 14z" fill="#FFBA00"/></svg>
                    Google Drive
                  </span>
                </button>
                <button style={{ ...s.btn, background: '#EDE9FE', color: '#5B21B6' }}
                  onClick={() => window.open('https://onedrive.live.com', '_blank')}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24"><path d="M10.5 18.5h8.25c2.07 0 3.75-1.68 3.75-3.75 0-1.86-1.35-3.41-3.13-3.71A5.25 5.25 0 0014.25 6c-2.07 0-3.86 1.2-4.73 2.94A4.5 4.5 0 005.25 13.5a4.5 4.5 0 00.56 2.18" fill="none" stroke="#0078D4" strokeWidth="1.5"/></svg>
                    OneDrive
                  </span>
                </button>
                <button style={{ ...s.btn, background: '#F0FDF4', color: '#059669' }}
                  onClick={() => window.open('https://www.dropbox.com', '_blank')}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24"><path d="M12 6.5L6 10l6 3.5L0 17l6 3.5 6-3.5 6 3.5 6-3.5-6-3.5 6-3.5-6-3.5-6 3.5z" fill="#0061FF"/></svg>
                    Dropbox
                  </span>
                </button>
              </div>

              {/* Folders */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {folders.map(f => (
                  <button key={f.id} onClick={() => setSelectedFolder(f.id)} style={{
                    padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600, border: '1px solid',
                    background: selectedFolder === f.id ? '#1E293B' : '#FFF',
                    color: selectedFolder === f.id ? '#FFF' : '#475569',
                    borderColor: selectedFolder === f.id ? '#1E293B' : '#E2E8F0',
                    cursor: 'pointer',
                  }}>{f.icon} {f.label}</button>
                ))}
              </div>

              {/* File List */}
              <div style={s.card}>
                {filteredDocs.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 32, color: '#94A3B8' }}>
                    <div style={{ fontSize: 40, marginBottom: 8 }}>📂</div>
                    <div>Κανένα έγγραφο σε αυτόν τον φάκελο</div>
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '2px solid #E2E8F0' }}>
                        {['Αρχείο', 'Τύπος', 'Μέγεθος', 'Ημ/νία', 'Ενέργειες'].map(h => (
                          <th key={h} style={{ textAlign: 'left', padding: '8px 12px', fontSize: 11, color: '#64748B', fontWeight: 600 }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDocs.map(doc => (
                        <tr key={doc.id} style={{ borderBottom: '1px solid #F1F5F9' }}>
                          <td style={{ padding: '10px 12px', fontSize: 13, fontWeight: 600, color: '#1E293B' }}>
                            📄 {doc.name}
                          </td>
                          <td style={{ padding: '10px 12px' }}>
                            <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, background: '#EFF6FF', color: '#2563EB', fontWeight: 600 }}>{doc.type}</span>
                          </td>
                          <td style={{ padding: '10px 12px', fontSize: 12, color: '#64748B' }}>{doc.size}</td>
                          <td style={{ padding: '10px 12px', fontSize: 12, color: '#64748B' }}>{new Date(doc.date).toLocaleDateString('el-GR')}</td>
                          <td style={{ padding: '10px 12px' }}>
                            <div style={{ display: 'flex', gap: 4 }}>
                              <button style={{ ...s.btn, background: '#F1F5F9', color: '#475569', padding: '4px 10px' }} title="Προβολή">👁️</button>
                              <button style={{ ...s.btn, background: '#F1F5F9', color: '#475569', padding: '4px 10px' }} title="Λήψη">⬇️</button>
                              <button style={{ ...s.btn, background: '#F1F5F9', color: '#475569', padding: '4px 10px' }} title="Αποστολή">📧</button>
                              <button style={{ ...s.btn, background: '#FEF2F2', color: '#DC2626', padding: '4px 10px' }}
                                onClick={() => setDocuments(prev => prev.filter(d => d.id !== doc.id))} title="Διαγραφή">🗑️</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

          {/* ===== ΗΜΕΡΟΛΟΓΙΟ TAB ===== */}
          {activeTab === 'calendar' && (
            <div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                <button style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}>➕ Νέα Προθεσμία</button>
                <button style={{ ...s.btn, background: '#EFF6FF', color: '#2563EB' }}
                  onClick={() => window.open('https://calendar.google.com', '_blank')}>📅 Google Calendar</button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {deadlines.map(dl => {
                  const daysLeft = Math.ceil((new Date(dl.date) - new Date()) / (1000 * 60 * 60 * 24));
                  const urgent = daysLeft <= 7;
                  const warning = daysLeft <= 30;
                  return (
                    <div key={dl.id} style={{
                      ...s.card, borderLeft: `4px solid ${urgent ? '#EF4444' : warning ? '#F59E0B' : '#10B981'}`,
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 700, color: '#1E293B' }}>{dl.title}</div>
                          <div style={{ fontSize: 12, color: '#64748B', marginTop: 2 }}>
                            {new Date(dl.date).toLocaleDateString('el-GR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                          </div>
                          <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                            <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 4,
                              background: dl.type === 'hearing' ? '#DBEAFE' : dl.type === 'statute' ? '#FEE2E2' : '#F0FDF4',
                              color: dl.type === 'hearing' ? '#1E40AF' : dl.type === 'statute' ? '#991B1B' : '#065F46',
                              fontWeight: 600 }}>
                              {dl.type === 'hearing' ? '⚖️ Συζήτηση' : dl.type === 'statute' ? '⏰ Παραγραφή' : '📋 Προθεσμία'}
                            </span>
                            <span style={{ fontSize: 10, color: '#94A3B8' }}>
                              Υπενθυμίσεις: {dl.reminder.join(', ')} ημέρες πριν
                            </span>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          <div style={{
                            fontSize: 28, fontWeight: 800,
                            color: urgent ? '#EF4444' : warning ? '#F59E0B' : '#10B981',
                          }}>
                            {daysLeft > 0 ? daysLeft : 'ΛΗΞΕ'}
                          </div>
                          <div style={{ fontSize: 10, color: '#64748B' }}>{daysLeft > 0 ? 'ημέρες' : '!'}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ===== ΟΙΚΟΝΟΜΙΚΑ TAB ===== */}
          {activeTab === 'finances' && (
            <div>
              {/* Summary Cards */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 12, marginBottom: 16 }}>
                {[
                  ['Αμοιβή', '€' + finances.honoraria.toLocaleString(), '#1E293B', '#F8FAFC'],
                  ['Δαπάνες', '€' + totalCosts.toLocaleString(), '#92400E', '#FEF3C7'],
                  ['Πληρωμένα', '€' + totalPaid.toLocaleString(), '#059669', '#F0FDF4'],
                  ['Υπόλοιπο', '€' + totalDue.toLocaleString(), totalDue > 0 ? '#DC2626' : '#059669', totalDue > 0 ? '#FEF2F2' : '#F0FDF4'],
                ].map(([label, val, color, bg], i) => (
                  <div key={i} style={{ ...s.card, background: bg, textAlign: 'center' }}>
                    <div style={{ fontSize: 11, color: '#64748B', marginBottom: 4 }}>{label}</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color }}>{val}</div>
                  </div>
                ))}
              </div>

              {/* Cost Breakdown */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div style={s.card}>
                  <div style={s.section}>💰 Ανάλυση Δαπανών</div>
                  {[
                    ['Δικαστικά Τέλη', finances.courtFees],
                    ['Γραμμάτιο Προείσπραξης ΔΣΑ', finances.grammatic],
                    ['Ένσημα', finances.stamps],
                    ['Αμοιβή Πραγματογνώμονα', finances.expertFees],
                    ['Λοιπά Έξοδα', finances.otherExpenses],
                  ].map(([label, val], i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #F1F5F9' }}>
                      <span style={{ fontSize: 13, color: '#475569' }}>{label}</span>
                      <span style={{ fontSize: 13, fontWeight: 600, color: '#1E293B' }}>€{val.toLocaleString()}</span>
                    </div>
                  ))}
                </div>

                <div style={s.card}>
                  <div style={s.section}>💳 Πληρωμές</div>
                  {finances.payments.map(p => (
                    <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #F1F5F9' }}>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#1E293B' }}>€{p.amount.toLocaleString()}</div>
                        <div style={{ fontSize: 11, color: '#64748B' }}>{new Date(p.date).toLocaleDateString('el-GR')} • {p.method}</div>
                      </div>
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                        <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, background: '#F0FDF4', color: '#059669', fontWeight: 600 }}>
                          ✅ {p.invoice}
                        </span>
                      </div>
                    </div>
                  ))}
                  <button style={{ ...s.btn, background: '#1E293B', color: '#FFF', marginTop: 12, width: '100%' }}>➕ Νέα Πληρωμή</button>
                </div>
              </div>
            </div>
          )}

          {/* ===== ΣΗΜΕΙΩΣΕΙΣ TAB ===== */}
          {activeTab === 'notes' && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {/* Notes */}
              <div>
                <div style={s.section}>📝 Σημειώσεις</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <input value={newNote} onChange={e => setNewNote(e.target.value)}
                    onKeyPress={e => {
                      if (e.key === 'Enter' && newNote.trim()) {
                        setNotes(prev => [{ id: Date.now(), date: new Date().toISOString().split('T')[0], text: newNote, pinned: false }, ...prev]);
                        setNewNote('');
                      }
                    }}
                    placeholder="Νέα σημείωση..." style={{ flex: 1, padding: '10px 14px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, outline: 'none' }} />
                  <button onClick={() => {
                    if (newNote.trim()) {
                      setNotes(prev => [{ id: Date.now(), date: new Date().toISOString().split('T')[0], text: newNote, pinned: false }, ...prev]);
                      setNewNote('');
                    }
                  }} style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}>➕</button>
                </div>
                {notes.sort((a, b) => b.pinned - a.pinned).map(note => (
                  <div key={note.id} style={{ ...s.card, borderLeft: note.pinned ? '3px solid #F59E0B' : '3px solid #E2E8F0' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontSize: 11, color: '#94A3B8' }}>{new Date(note.date).toLocaleDateString('el-GR')}</span>
                      <button onClick={() => setNotes(prev => prev.map(n => n.id === note.id ? { ...n, pinned: !n.pinned } : n))}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 14 }}>
                        {note.pinned ? '📌' : '📍'}
                      </button>
                    </div>
                    <div style={{ fontSize: 13, color: '#1E293B', lineHeight: 1.6 }}>{note.text}</div>
                  </div>
                ))}
              </div>

              {/* Todos */}
              <div>
                <div style={s.section}>✅ Εκκρεμότητες</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <input value={newTodo} onChange={e => setNewTodo(e.target.value)}
                    onKeyPress={e => {
                      if (e.key === 'Enter' && newTodo.trim()) {
                        setTodos(prev => [{ id: Date.now(), text: newTodo, done: false, due: '', priority: 'medium' }, ...prev]);
                        setNewTodo('');
                      }
                    }}
                    placeholder="Νέα εκκρεμότητα..." style={{ flex: 1, padding: '10px 14px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, outline: 'none' }} />
                  <button onClick={() => {
                    if (newTodo.trim()) {
                      setTodos(prev => [{ id: Date.now(), text: newTodo, done: false, due: '', priority: 'medium' }, ...prev]);
                      setNewTodo('');
                    }
                  }} style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}>➕</button>
                </div>
                {todos.sort((a, b) => a.done - b.done).map(todo => (
                  <div key={todo.id} style={{
                    ...s.card, opacity: todo.done ? 0.6 : 1,
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>
                    <input type="checkbox" checked={todo.done}
                      onChange={() => setTodos(prev => prev.map(t => t.id === todo.id ? { ...t, done: !t.done } : t))}
                      style={{ width: 18, height: 18, accentColor: '#1E293B', cursor: 'pointer' }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#1E293B', textDecoration: todo.done ? 'line-through' : 'none' }}>{todo.text}</div>
                      {todo.due && <div style={{ fontSize: 11, color: '#94A3B8' }}>Προθεσμία: {new Date(todo.due).toLocaleDateString('el-GR')}</div>}
                    </div>
                    <span style={{
                      fontSize: 10, padding: '2px 8px', borderRadius: 4, fontWeight: 600,
                      background: todo.priority === 'high' ? '#FEE2E2' : '#FEF3C7',
                      color: todo.priority === 'high' ? '#DC2626' : '#92400E',
                    }}>{todo.priority === 'high' ? '🔴 Υψηλή' : '🟡 Μεσαία'}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ===== ΝΟΜΟΛΟΓΙΑ TAB ===== */}
          {activeTab === 'jurisprudence' && (
            <div>
              <div style={s.section}>⚖️ Σχετική Νομολογία & Νομοθεσία</div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                <button style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}
                  onClick={() => { /* TODO: open search with case context */ }}>
                  🔍 Αναζήτηση Σχετικής Νομολογίας
                </button>
                <button style={{ ...s.btn, background: '#EFF6FF', color: '#2563EB' }}>➕ Προσθήκη Νομολογίας</button>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                {/* Linked Case Law */}
                <div style={s.card}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1E293B', marginBottom: 10 }}>📚 Συνδεδεμένη Νομολογία</div>
                  {[
                    { num: 'ΑΠ 142/2014', title: 'Αναίρεση - Παραβίαση νόμου', relevance: 'Υψηλή' },
                    { num: 'ΑΠ 957/2024', title: 'Σύμβαση μίσθωσης - Καταγγελία', relevance: 'Μεσαία' },
                    { num: 'ΣτΕ 1023/2023', title: 'Διοικητική πράξη - Ακύρωση', relevance: 'Χαμηλή' },
                  ].map((item, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #F1F5F9', cursor: 'pointer' }}
                      onClick={() => alert('TODO: Open document popup')}>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#2563EB' }}>{item.num}</div>
                        <div style={{ fontSize: 12, color: '#64748B' }}>{item.title}</div>
                      </div>
                      <span style={{
                        fontSize: 10, padding: '2px 8px', borderRadius: 4, fontWeight: 600,
                        background: item.relevance === 'Υψηλή' ? '#F0FDF4' : item.relevance === 'Μεσαία' ? '#FEF3C7' : '#F1F5F9',
                        color: item.relevance === 'Υψηλή' ? '#059669' : item.relevance === 'Μεσαία' ? '#92400E' : '#64748B',
                      }}>{item.relevance}</span>
                    </div>
                  ))}
                </div>

                {/* Linked Laws */}
                <div style={s.card}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1E293B', marginBottom: 10 }}>📖 Σχετική Νομοθεσία</div>
                  {[
                    { num: 'Ν. 4738/2020', title: 'Κώδικας Πτώχευσης', articles: 'Άρθρα 1-5' },
                    { num: 'ΑΚ 574-618', title: 'Μίσθωση Πράγματος', articles: 'Γενικές Διατάξεις' },
                    { num: 'ΠΔ 34/1995', title: 'Εμπορικές Μισθώσεις', articles: 'Άρθρα 1-15' },
                  ].map((item, i) => (
                    <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #F1F5F9' }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#1E293B' }}>{item.num}</div>
                      <div style={{ fontSize: 12, color: '#64748B' }}>{item.title} • {item.articles}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseDetailView;
